import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Meta } from '@angular/platform-browser';
@Injectable()
export class CanonicalService {
  constructor(@Inject(DOCUMENT) private dom : Document,
    private meta: Meta,
    private translateService: TranslateService,) { }
  setCanonicalURL(url?: string) {

    const canonicalUrl = 'https://runeterra.ar' + this.dom.defaultView.location.pathname;
    const head = this.dom.getElementsByTagName('head')[0];

    if(head != undefined){

    var element: HTMLLinkElement = this.dom.querySelector(`link[rel='canonical']`) || null;
    if (element == null) {
      element = this.dom.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel', 'canonical');
    element.setAttribute('href', canonicalUrl);

  }
    //var canURL : string = url == undefined ? this.dom.URL : url;

    //canURL = canURL.replace("https://app.","https://")

    //const canonical = document.querySelector('link[rel="canonical"]');
    //if (canonical !== null) {
    //  canonical.setAttribute('href', canURL);
    //} else {
    //  const link: HTMLLinkElement = this.dom.createElement('link');
    //  link.setAttribute('rel', 'canonical');
    //  this.dom.head.appendChild(link);
    //  link.setAttribute('href', canURL);
    //}

  }

  UpdateEvent(event: any) {
 
    var title = event['title'];
    var description = event['description'];
 
    if (title != undefined) {

      this.translateService.get(title).toPromise().then((res: string) => {

        if (title) {
          title = res;
        }

        //Google
        this.meta.updateTag({ name: 'title', content: title });
        //Twitter
        this.meta.updateTag({ name: 'twitter:title', content: title });
        //META (Facebook, Whatsapp)
        this.meta.updateTag({ property: 'og:title', content: title });

      });
    }

    if (description != undefined) {

      this.translateService.get(description).toPromise().then((res: string) => {
         
        if (description) {
          description = res;
        }

        //Google
        this.meta.updateTag({ name: 'description', content: description });

        //Twitter
        this.meta.updateTag({ name: 'twitter:description', content: description });

        //META (Facebook, Whatsapp)
        this.meta.updateTag({ property: 'og:description', content: description });
   
      });

    }

    //Robots
    if (event.robots == undefined) {
      this.meta.updateTag({ name: 'robots', content: 'noindex,follow' });
    } else {
      this.meta.updateTag({ name: 'robots', content: event['robots'] });
    }

    this.meta.updateTag({ content: "website", property: "og:type" });

    var img = "https://cdn.runeterra.ar/assets/img/runeterra-2024-index.png";
    this.meta.updateTag({ name: 'twitter:image', content: img });
    this.meta.updateTag({ property: 'og:image', content: img });
     
  }

}
